exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-split[data-v-1966e105]{height:100%;border:1px solid #dcdee2}.demo-split-pane[data-v-1966e105]{padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1966e105","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdEducationPlan/parts/pdPatientEducationPlan/pdPatientEducationPlanStep.vue
// module id = o1iV
// module chunks = 0